import { useLocation } from "react-router-dom";
import NewHeader from "@/components/NewHeader";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { getPathWithoutLanguage } from "@/utils/languageUtils";
import {
  WHATSAPP_AUTHORIZATION_LAST_UPDATED,
  WHATSAPP_DISPLAY_NAME,
} from "@/constants/whatsappAuthorization";

const CONTACT_EMAIL = "info@beatenberg-resortspa.ch";

const PAGE_TITLE = "WhatsApp Communication Authorization";

/**
 * Meta / askng.it proof page — English only, not linked in site navigation.
 */
const WhatsAppAuthorization = () => {
  const location = useLocation();
  const canonicalPath = getPathWithoutLanguage(location.pathname);

  return (
    <div className="min-h-screen bg-white" data-oid="whatsapp-auth-page-root">
      <SEO
        title={`${PAGE_TITLE} for Beatenberg Resort & Spa`}
        description="Beatenberg Resort & Spa authorizes askng.it B.V. to send and receive WhatsApp Business messages on our behalf for guest communications."
        canonical={canonicalPath}
        language="en"
      />
      <NewHeader lightBackground data-oid="whatsapp-auth-header" />

      <main
        className="mx-auto max-w-3xl px-5 pb-24 pt-28 sm:px-8 sm:pt-32 lg:pb-32"
        data-oid="whatsapp-auth-main"
      >
        <header className="border-b border-neutral-200 pb-10">
          <p className="font-lato text-[11px] font-semibold uppercase tracking-[0.28em] text-neutral-500">
            Beatenberg Resort &amp; Spa
          </p>
          <h1 className="mt-5 font-playfair text-3xl font-semibold tracking-tight text-neutral-900 sm:text-[2.125rem]">
            {PAGE_TITLE}
          </h1>
          <p className="mt-4 font-lato text-sm text-neutral-600">
            Last updated: {WHATSAPP_AUTHORIZATION_LAST_UPDATED}
          </p>
        </header>

        <div className="mt-10 space-y-6 font-lato text-[15px] leading-[1.65] text-neutral-700">
          <p>
            <strong>Beatenberg Resort &amp; Spa</strong> hereby authorizes{" "}
            <strong>askng.it B.V.</strong>, a company based in the Netherlands,
            to send and receive WhatsApp Business messages on our behalf using
            the display name{" "}
            <strong>&quot;{WHATSAPP_DISPLAY_NAME}&quot;</strong>.
          </p>

          <p>
            This authorization covers customer service communication for guests
            of Beatenberg Resort &amp; Spa, including booking confirmations,
            pre-arrival information, in-stay support, and post-stay follow-up.
          </p>

          <p>
            <strong>Property:</strong> Beatenberg Resort &amp; Spa
            <br />
            <strong>Address:</strong> Spirenwaldstrasse 351, 3803 Beatenberg, CH
            <br />
            <strong>Authorized service provider:</strong> askng.it B.V.,
            Herengracht 420, 1017 BZ Amsterdam, Netherlands, KvK 78141435
            <br />
            <strong>Contact:</strong>{" "}
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="font-medium text-neutral-900 underline decoration-neutral-400 underline-offset-[5px] transition-colors hover:decoration-neutral-900"
            >
              {CONTACT_EMAIL}
            </a>
          </p>
        </div>
      </main>

      <Footer data-oid="whatsapp-auth-footer" />
    </div>
  );
};

export default WhatsAppAuthorization;
